import type { CampaignPageThemesQuery } from 'src/types';
import query from '../themes-query.graphql';
import { usePageQuery } from 'src/hooks/use-page-query';

export function useThemesPageQuery() {
  return usePageQuery<CampaignPageThemesQuery>({
    query,
    routeName: 'themes',
  });
}
